<template>
  <d-form>
    <d-form-row class="form-group">
      <d-col cols="12" md="10">
        <label>Texto:</label>
        <div class="teste">
          <editor
            :model.sync="model.text"
            ref="editor"
            reference="text"
            @ready="setQuill"
            :editorOption="{modules: {
              toolbar: null,
              keyboard: {
                bindings: {
                  bold: {
                    key: 'B',
                    shortKey: true,
                    handler: selectWord
                  },
                }
              }
            }}"
          />
        </div>
      </d-col>
      <d-col cols="12" md="1" >
        <d-row>
          <d-col cols="12">
            <label>Selecionadas:</label>
            <d-input class="form-control" v-model="model.list.length" readonly />
          </d-col>
        </d-row>
        <d-row>
          <d-col cols="12">
            <d-button type="button" class="mt-3 btn" @click="generateResult">Gerar</d-button>
            <d-button type="button" class="mt-3 btn btn-danger" @click="cleanText">Limpar</d-button>
            <d-button type="button" class="mt-3 btn btn-success" @click="download">Baixar</d-button>
          </d-col>
        </d-row>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group">
      <d-col cols="12" md="4">
        <label>Lista:</label>
        <ol class="pl-3">
          <li class="cursor-pointer" v-for="(word, index) in model.list" :key="index" @click="removeWord(index)">{{word}}</li>
        </ol>
      </d-col>
      <d-col cols="12" md="8">
        <label>Texto gerado:</label>
        <editor :model.sync="model.result" reference="result" :editorOption="{modules: { toolbar: null }}" />
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import Editor from '_shared/Editor.vue';
import htmlToRtf from 'html-to-rtf';

export default {
  name: 'generate-form',
  components: {
    Editor,
  },
  computed: {
  },
  data() {
    return {
      timer: null,
      quill: null,
      model: {
        text: '',
        list: [],
        result: '',
      },
    };
  },
  methods: {
    cleanText() {
      this.model.text = '';
      this.model.list = [];
      this.model.count = 0;
    },
    setQuill(quill) {
      this.quill = quill;
    },
    selectWord(range) {
      const word = (document.selection && document.selection.createRange().text) ||
            (window.getSelection && window.getSelection().toString());
      const formatted = word.toUpperCase();

      if (this.model.list.includes(formatted)) {
        // eslint-disable-next-line
        alert('Palavra repetida!');
      } else {
        this.model.list.push(formatted);

        const { index, length } = range;
        const options = [];
        if (index > 0) {
          options.push({ retain: index });
        }
        options.push({ delete: length });
        options.push({ insert: formatted });
        this.quill.updateContents({
          ops: options,
        });
        this.quill.formatText(index, length, 'bold', true);
      }
    },
    removeWord(index) {
      const word = this.model.list[index];
      this.model.list.splice(index, 1);
      this.model.text = this.model.text.replace(`<strong>${word}</strong>`, word.toLowerCase());
    },
    generateResult() {
      this.model.result += this.model.text;
      this.model.result += '<p><br></p>';
      this.model.result += this.model.list.join('<br>');
      this.model.result += '<p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>';
    },
    download() {
      const c = document.createElement('a');
      c.download = 'texto-gerado.rtf';
      let text = htmlToRtf.convertHtmlToRtf(this.model.result);
      text = text.replaceAll(/\s}\s/g, ' }');
      text = text.replaceAll(/'93 {/g, item => item.replace(' ', ''));
      text = text.replaceAll(/\s}[,.;:!?`'"\\'94]/g, item => item.substr(1));
      const t = new Blob([text], {
        type: 'text/plain',
      });
      c.href = window.URL.createObjectURL(t);
      c.click();
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
  &:hover {
    color: red;
  }
}
.text-area {
  height: 200px;
}
</style>
